import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from './store'
import ElementUI from 'element-ui';
import './permission' // permission control
import './utils/permission.js'
import 'element-ui/lib/theme-chalk/index.css';
import cusHeader from '@/components/cus-header/cus-header' //主框架
import language from './utils/lang/zn.js'
Vue.prototype.$language = language
// console.log(language)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.component('cus-header', cusHeader)
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')